import React, { useEffect, useState } from 'react';
import {
  Box,
  Tab,
  Tabs,
  Typography,
  Card,
  CardContent,
  TextField,
  Button,
  Grid,
  Paper,
  IconButton,
  styled,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell
} from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import { BLACK, BLUE_LIGHT_RGB_BORDER, BLUE_MAIN, GRAY_LIGHT_RGB_BORDER, GREEN_LOGO, GREEN_MAIN, WHITE } from '../theme/colors';
import { useTranslationContext } from '../hooks/translations/translationsProvider';
import settings from '../utilities/settings';
import { IBuy, IBuyRequestModel } from '../models/buy/Buy';
import BankTransfer from './Buy/BankTrasfer';
import BankTransferResponse from './Buy/BankTransferResponse';
import { useWaiter } from '../hooks/waiter/WaiterProvider';
import { buyRequest } from '../hooks/actions/buy';
import CheckBoxTermsAndConditions from './CheckBoxTermsAndConditions';
import AccountBalanceIcon from "@mui/icons-material/AccountBalanceOutlined";
import CurrencyBitcoinIcon from "@mui/icons-material/CurrencyBitcoin";
import { delay } from '../utilities/delay';
import { dashboard } from '../hooks/actions/dashboard';

const TabsCustom = styled(Tabs)(({theme})=>({
    minWidth: '105px',                                      
    [theme.breakpoints.up('xs')]: {
        maxWidth: '150px', 
    },
    "& .MuiTabs-indicator":{
        backgroundColor:"transparent",
        width: "0px"
    }
}))

const TabCustom = styled(Tab)(({theme})=>({
    fontSize:'10px',
    fontFamily: 'poppins', 
    color: GREEN_MAIN,
    padding:'9px',    
    textTransform: "none", 
    fontWeight:'normal',                                 
    [theme.breakpoints.up('sm')]: {
    },
    "&.Mui-selected": {
        color: GREEN_MAIN,
        fontWeight: "bold",
    },
}))

const FormCustom = styled('form')(({theme})=>({
    width:'100%',                                      
    [theme.breakpoints.up('md')]: {
        width:'80%',
    },
}))

const ResponseBox = styled(Box)(({theme})=>({
    width:'100%',
    marginTop:"30px",                                      
    [theme.breakpoints.up('md')]: {
        width:'80%',
    },
}))

// ICONE E INFORMAZIONI DELLE TABS
const BitcoinLogo = <Box
  sx={{
    border: '1px solid '+ GREEN_MAIN,      // colore di sfondo (modificabile)
    borderRadius: '50%',             // cerchio
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}
>
  <CurrencyBitcoinIcon sx={{ color: GREEN_MAIN}} />
</Box>

const paymentMethods = [
    { 
        label: 'Bonifico Bancario', 
        value: 'bankTransfer', 
        ico: <AccountBalanceIcon style={{ color: GREEN_MAIN }} /> , 
        type: 0, 
        title: "Acquista ASSO con bonifico bancario",
        enabled: true,
    },
    // { label: 'PayPal', value: 'paypal', ico: '/paypal.png', type: 1 },
    // { label: 'Carta di Credito', value: 'creditcard', ico: < img src='/creditcard.png' .... />, type: 2 },
    // { 
    //     label: 'Bitcoin', 
    //     value: 'bitcoin', 
    //     ico: BitcoinLogo, 
    //     type: 3,
    //     title: "Acquista ASSO con Bitcoin",
    //     enabled: false, 
    // },
];


interface PaymentData {
  amount: string;
  type: number;
}

interface PaymentFormProps {
    setTitle:React.Dispatch<React.SetStateAction<string>>
}

const PaymentForm: React.FC<PaymentFormProps> = ({setTitle}) => {
    const [selectedTab, setSelectedTab] = useState(0);
    const [response, setResponse] = useState<IBuy | null>(null);
    const {t} = useTranslationContext();
    
    const [feeFixedInDivisa, setFeeFixedInDivisa] = useState<number>(0)
    const [feePerc, setFeePerc] = useState<number>(0);
    const [feePercAmountInDivisa, setFeePercAmountInDivisa] = useState<number>(0);
    // const [netAmount, setNetAmount] = useState<number>(0);
    const [divisa, setDivisa] = useState<string>("0");

    // CONTROVALORE GENERALE (EUR, BITCOIN ecc..)
    const [amount, setAmount] = useState('');
    // const [error, setError] = useState(false);
    // const [errorMessage, setErrorMessage] = useState('')
    
    // FINE BANCA
    const [isSended, setIsSended] = useState(false);
    const [mainErrorMex, setMainErrorMex]=useState<string | null>(null);
    const [isChecked, setIsChecked] = useState(false); 

    // ASSO
    const [amountAvaiable, setAmountAvaible] = useState<number>(0);
    const [assoAmountRequest, setAssoAmountRequest] = useState('');
    const [assoAmountRequestError, setAssoAmountRequestError] = useState(false);
    const [assoAmountRequestErrorMessage, setAssoAmountRequestErrorMesssage] = useState('');
    // FINE ASSO

    const {setWaiterView} = useWaiter();

    useEffect(()=>{
        setWaiterView(true)
        delay(500).finally(()=>{
            dashboard()
                .then(resp => {
                    setAmountAvaible(resp.balance)
                })
                .catch(error => {
                    // initLoad.current = false
                    console.log(error)
                })
            setWaiterView(false)
        })
    },[])

    useEffect(()=>{
        setTitle(paymentMethods[selectedTab].title);
    },
    [selectedTab, paymentMethods])

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setSelectedTab(newValue);
        setAmount("");
    };

    useEffect(()=>{
        if(assoAmountRequest === '' || !assoAmountRequest){
            setAmount(assoAmountRequest); // in caso di banca
        }
        let fixedFee;
        let percFee;
        let divisa;
        let ratioEurToAsso = settings.BuyTokens.RatioEurToAsso; // da usare anche per le future altre conversioni
        const amountInEur = Math.round(
            ( parseFloat(assoAmountRequest) / ratioEurToAsso ) * 100
        ) / 100;

        switch(selectedTab){
            // BONIFICO
            case 0:{
                fixedFee = settings.BuyTokens.Bonifico.FixedFee; // fee fissa
                percFee = settings.BuyTokens.Bonifico.PercentFee; 
                divisa = settings.BuyTokens.Bonifico.Divisa;
                
                const feeWithAmount = Math.round(
                    (amountInEur / ( 100 - parseFloat(percFee) ) * 100 ) * 100
                ) / 100;

                const percInDivisa = Math.round(
                    (feeWithAmount - amountInEur) * 100
                ) / 100;

                const total = (feeWithAmount + feeFixedInDivisa).toFixed(2);
                
                setFeePercAmountInDivisa(percInDivisa); // ok
                setFeeFixedInDivisa(fixedFee); // ok
                setFeePerc(percFee); // ok
                setDivisa(divisa); //ok
                setAmount(total);
                break;
            }
        }
    },[selectedTab, assoAmountRequest])

    useEffect(()=>{
        setMainErrorMex(null);
        setResponse(null);
        setIsSended(false);
        setIsChecked(false);
    },[selectedTab])

    const handleInputAssoChange = (e: React.ChangeEvent<HTMLInputElement>, type:number) => {
        let maxAmount = settings.BuyTokens.Bonifico.MaxAmountInEuro;
        let minAmount = settings.BuyTokens.Bonifico.MinAmountInEuro;

        setAssoAmountRequestError(false);
        setAssoAmountRequestErrorMesssage('');
        const value = e.target.value;
        const regex = /^\d*\.?\d{0,2}$/;
        if(value === '' || !value){
            setAssoAmountRequest('');
            setAssoAmountRequestError(false);
            setAmount('');
            return;
        }

        if (value.includes('.')) {
            const [integerPart, decimalPart] = value.split('.');
            if (decimalPart.length > 2) {
                setAssoAmountRequestError(false);
                return;
            }
        }

        if(!regex.test(value)){
            setAssoAmountRequestErrorMesssage(t("Inserisci un importo valido"))
            setAssoAmountRequestError(true)
        }

        if (parseFloat(value) >= 0) {
            if(parseFloat(value) > parseFloat(maxAmount)){
                setAssoAmountRequest(maxAmount);
                return;
            }
            setAssoAmountRequest(value);
            setAssoAmountRequestError(false);
        } else {
            setAssoAmountRequestErrorMesssage(t("Devi acquistare almeno ASSO: ") + parseFloat(minAmount).toFixed(2))
            setAssoAmountRequestError(true);
            return;
        }

    }

    const handleBlur = (type:number) => {
        let maxAmount = settings.BuyTokens.Bonifico.MaxAmountInEuro;
        let minAmount = settings.BuyTokens.Bonifico.MinAmountInEuro;

        if (!assoAmountRequestError && assoAmountRequest) {
            if(parseFloat(assoAmountRequest) < parseFloat(minAmount))
            {
                setAssoAmountRequestErrorMesssage(t("Devi acquistare almeno ASSO: ") + parseFloat(minAmount).toFixed(2));
                setAssoAmountRequestError(true);
            }
            const newAmount = parseFloat(assoAmountRequest).toFixed(2)
            setAssoAmountRequest(newAmount);
            setAssoAmountRequestError(false);
        }
    };

    const handleSubmit = async (e: React.FormEvent) => {

        e.preventDefault();
        setIsSended(true);
        setWaiterView(true);
        setMainErrorMex(null);
        if(isChecked){
            const newReq:IBuyRequestModel = {
                amount: parseFloat(assoAmountRequest),
                buyType: selectedTab,
                acceptTerms: isChecked
            }
            try{
                const buy = await buyRequest(newReq)
                setResponse(buy);
            }catch(e:any){
                console.log(e);
                setResponse(null);
                setMainErrorMex(e.data)
                setIsSended(false);
            }
        }
        setWaiterView(false);
    };

    return (
        <Box sx={{width:'100%', overflow: 'hidden', maxWidth: '100%', fontFamily:'poppins'}}>
            <Paper sx={{ 
                width: '100%', 
                display: 'flex', 
                minHeight: '350px', 
                border: 1, 
                borderColor: 'transparent',  
                overflow: 'hidden',
                maxWidth: '100%', // Limita la larghezza massima del Paper
                boxSizing: 'border-box',
            }}>
                <TabsCustom
                    orientation="vertical"
                    variant="scrollable"
                    value={selectedTab}
                    onChange={handleTabChange}
                    sx={{ borderRight: 2, borderColor: `${GREEN_LOGO}30` }}
                >
                    {paymentMethods.map((method, index) => (
                        <TabCustom
                            key={index}
                            icon={ method.ico
                                    // <img
                                    //     src={method.ico}
                                    //     alt={`${method.label}`}
                                    //     style={{ width: "auto", height: 25 }}
                                    // />
                            }
                            label={t(method.label)}
                            sx={{ 
                                borderBottom: 1, 
                                borderColor: 'transparent' 
                            }}
                        />
                    ))}
                </TabsCustom>
                <Box sx={{ flexGrow: 1, p: 3, position: 'relative', maxWidth: '100%', boxSizing: 'border-box' }}>
                    {response && (
                        <IconButton
                            onClick={() => window.print()}
                            sx={{ position: 'absolute', top: 16, right: 16 }}
                        >
                            <PrintIcon />
                        </IconButton>
                    )}

                    <Card sx={{ backgroundColor: 'transparent', boxShadow: 'none', }}>
                        <CardContent 
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                //padding: '24px 0 0 0',
                                flexDirection: 'column',
                                maxWidth: '100%', // Limita il contenuto a non superare il suo contenitore
                                boxSizing: 'border-box',
                        }}>
                            { !response &&
                                <FormCustom onSubmit={handleSubmit}>
                                    <Grid container spacing={2} justifyContent={'center'} sx={{maxWidth: '100%', boxSizing: 'border-box' }}>
                                        <Grid item xs={12}>
                                        {
                                            paymentMethods[selectedTab].type === 0 && // bonifico
                                            (paymentMethods[selectedTab].enabled ? 
                                                <Box>
                                                    <BankTransfer
                                                        amountAvaiable={amountAvaiable}
                                                        assoAmountRequest={assoAmountRequest}
                                                        setAssoAmountRequest={setAssoAmountRequest}
                                                        handleInputAssoChange={handleInputAssoChange}
                                                        assoAmountRequestError={assoAmountRequestError}
                                                        setAssoAmountRequestError={setAssoAmountRequestError}
                                                        assoAmountRequestErrorMessage={assoAmountRequestErrorMessage}
                                                        typeTab={paymentMethods[selectedTab].type}
                                                    
                                                        amount={amount}
                                                        divisa={divisa}
                                                        feeFixedInDivisa={feeFixedInDivisa}
                                                        feePerc={feePerc}
                                                        feePercAmountInDivisa={feePercAmountInDivisa}

                                                        handleBlur={handleBlur}      
                                                    />
                                                    <CheckBoxTermsAndConditions isChecked={isChecked} setIsChecked={setIsChecked}/>
                                                    <Box paddingBottom={6}/>
                                                </Box> : 
                                                <Typography>
                                                    {t("Tipologia di acquisto non ancora disponibile")}
                                                </Typography>
                                            )      
                                        }
                                        {/* {
                                            paymentMethods[selectedTab].type === 3 && // bitcoin
                                            (paymentMethods[selectedTab].enabled ? 
                                                <Box> */}
                                                    {/* <BankTransfer
                                                        amountAvaiable={amountAvaiable}
                                                        assoAmountRequest={assoAmountRequest}
                                                        setAssoAmountRequest={setAssoAmountRequest}
                                                        handleInputAssoChange={handleInputAssoChange}
                                                        assoAmountRequestError={assoAmountRequestError}
                                                        setAssoAmountRequestError={setAssoAmountRequestError}
                                                        assoAmountRequestErrorMessage={assoAmountRequestErrorMessage}
                                                        typeTab={paymentMethods[selectedTab].type}
                                                    
                                                        amount={amount}
                                                        divisa={divisa}
                                                        feeFixedInDivisa={feeFixedInDivisa}
                                                        feePerc={feePerc}
                                                        feePercAmountInDivisa={feePercAmountInDivisa}

                                                        handleBlur={handleBlur}      
                                                    />
                                                    <CheckBoxTermsAndConditions isChecked={isChecked} setIsChecked={setIsChecked}/> */}
                                                {/* </Box> : 
                                                <Typography>
                                                    {t("Tipologia di acquisto non ancora disponibile")}
                                                </Typography>
                                            )      
                                        } */}
                                        </Grid>

                                        {/** BUTTON */}
                                        {paymentMethods[selectedTab].enabled && <Grid item xs={8} sm={3}>
                                            <Button type="submit" variant="contained" disabled={isSended || assoAmountRequest === '' || !isChecked} 
                                                sx={{
                                                    bgcolor: GREEN_LOGO,
                                                    "&:hover": { bgcolor: "darkgreen" },
                                                    color:WHITE,
                                                    border: "1px solid " + GREEN_LOGO,
                                                    fontSize:'1.2rem'
                                                }}>
                                                {t("Invia")}
                                            </Button>
                                        </Grid>}
                                        {
                                            mainErrorMex && <Grid item xs={12}>
                                                <Typography fontSize="0.75rem" color="red" 
                                                    sx={{
                                                        display: '-webkit-box',
                                                        WebkitLineClamp: 3, // Limita il numero di righe del testo
                                                        WebkitBoxOrient: 'vertical',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'normal',
                                                        wordWrap: 'break-word',
                                                        maxWidth: '100%', // Impedisce l'uscita dal contenitore
                                                    }}
                                                >
                                                    {mainErrorMex}
                                                </Typography>
                                            </Grid>
                                        }

                                    </Grid>
                                </FormCustom>
                            }

                            { response && 
                                <ResponseBox>
                                    {
                                        paymentMethods[selectedTab].type === 0 && <BankTransferResponse divisa={divisa} response={response} />
                                    }
                                    {/** OTHER RESPONSES */}
                                </ResponseBox> 
                            }
                        </CardContent>
                    </Card>
                </Box>
            </Paper>
        </Box>
    );
};

export default PaymentForm;
